import { render, staticRenderFns } from "./ExternalLinkForm.vue?vue&type=template&id=1d673794"
import script from "./ExternalLinkForm.vue?vue&type=script&lang=js"
export * from "./ExternalLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports